import { Tag } from "antd";
import React from "react";
import PhoneNumber from "./PhobeNumber";
import { Link } from "react-router-dom";
import CrmBadge from "./CrmBadge";
import { useSelector } from "react-redux";
import { isPermitted } from "../utils/PermissionManager";

export default function CustomerName({ data, country, nameOnly, withBadge }) {
  const roles = useSelector((state) => state.auth.profile?.roles);
  return (
    <div
      className="flex"
      style={{
        gap: "1rem",
        textTransform: "none",
      }}
    >
      <div
        className="flex flexColumn"
        style={{
          alignItems: "flex-start",
        }}
      >
        {isPermitted(roles, ["admin", "crm"]) ? (
          <Link
            to={`/crm/customer/${data?._id}`}
            style={{
              textAlign: "left",
              display: "flex",
              gap: "0.5rem",
              alignItems: "center",
            }}
          >
            {data?.name}
            {withBadge && data.badge && (
              <div>
                <CrmBadge name={data.badge} />
              </div>
            )}
          </Link>
        ) : (
          <div
            style={{
              textAlign: "left",
              display: "flex",
              gap: "0.5rem",
              alignItems: "center",
            }}
          >
            {data?.name}
            {withBadge && data.badge && (
              <div>
                <CrmBadge name={data.badge} />
              </div>
            )}
          </div>
        )}
        {!nameOnly && (
          <div>
            {data?.phone ? (
              <PhoneNumber phone={data?.phone} />
            ) : data?.emergency_phone ? (
              <PhoneNumber phone={data?.emergency_phone} />
            ) : (
              data?.email
            )}
          </div>
        )}
      </div>
      {country && <Tag color="red">{country}</Tag>}
    </div>
  );
}
